import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../../components/layout/Header'
import Sidebar from '../../../components/layout/Sidebar'
import ProductionBarByMonth from '../../../components/analytics/production/ProductionBarByMonth'

const ProductionAnalytics = ({ nav }) => {
    return (
        <>
            <div className={nav.isSidebar}>
                <Header nav={nav} />
                <Sidebar nav={nav} />
                {/*start content*/}
                <main className="page-content">
                    {/*breadcrumb*/}
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Dashboard</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/">
                                            <i className="bx bx-home-alt" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Sales Analytics
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="row ">
                        <div className="col-xl-12 mx-auto ">
                            <div className='row'>
                                <div className="col-md-8 col-lg-8 col-xl-8">
                                    <h6 className="mb-0 "><i className="fadeIn animated bx bx-line-chart" />
                                        Production analytics sorted by product type - Line Graph
                                    </h6>
                                </div>
                            </div>
                            {/* {!data ? (<Loader />) : (<LineChart analData={data} />)} */}
                            <ProductionBarByMonth />
                        </div>
                    </div>
                    <hr />
                </main>

                <div className="overlay nav-toggle-icon" />
                <a href="" className="back-to-top">
                    <i className="bx bxs-up-arrow-alt" />
                </a>
            </div>
        </>
    )
}

export default ProductionAnalytics